import React from 'react'
import { Loader } from 'rsuite';

function ShowHideModal({ hiddenId, setHiddenId, loading, hideUniv, title, hidden }) {
    return (
        <div className="p-6">
            <div className="text-center space-y-4">
                <div className="w-16 h-16 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {hidden ? "Activate" : "Deactivate"} {title}
                    </h3>
                    <p className="text-gray-600">
                        Are you sure you want to{" "}
                        <span className="font-medium">
                            {hidden ? "activate" : "deactivate"}
                        </span>{" "}
                        <span className="font-semibold text-gray-900">
                            {hiddenId?.title}
                        </span>{" "}?
                    </p>
                </div>
            </div>

            <div className="flex justify-center space-x-3 mt-8">
                <button
                    className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
                    onClick={() => {
                        setHiddenId(false);
                    }}
                >
                    Cancel
                </button>
                <button
                    className={`px-6 py-2.5 text-white rounded-lg transition-all duration-200 font-medium shadow-md hover:shadow-lg ${hidden
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-red-600 hover:bg-red-700"
                        }`}
                    onClick={() => {
                        return !loading ? hideUniv() : null;
                    }}
                >
                    {!loading ? (
                        <>
                            {hidden ? "Activate" : "Deactivate"}
                        </>
                    ) : (
                        <Loader size="sm" />
                    )}
                </button>
            </div>
        </div>
    )
}

export default ShowHideModal